import React from 'react';
import { Box, Container, Typography, Grid, Paper } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CATEGORIES } from './Header';

const toolCount = CATEGORIES.reduce((n, cat) => n + cat.tools.length, 0);

/**
 * Crawlable all-tools directory rendered on the homepage: every tool is one
 * real <a href> away from "/", which is the strongest internal-linking signal
 * we can give crawlers (and the pattern every major PDF site leads with).
 * Driven by the same CATEGORIES data as the header mega-menu so it can never
 * drift out of sync when tools are added.
 */
export default function ToolsGrid() {
  const { t } = useTranslation();

  return (
    <Box component="section" id="all-tools" sx={{ py: { xs: 5, md: 8 } }}>
      <Container maxWidth="lg">
        <Typography
          variant="h2"
          sx={{ fontSize: { xs: '1.5rem', md: '2rem' }, fontWeight: 700, textAlign: 'center', mb: 1 }}
        >
          {t('toolsGrid.title')}
        </Typography>
        <Typography color="text.secondary" textAlign="center" mb={5}>
          {t('toolsGrid.subtitle', { count: toolCount })}
        </Typography>

        {CATEGORIES.map((cat) => (
          <Box key={cat.labelKey} mb={4}>
            <Typography
              variant="overline"
              component="h3"
              sx={{ color: 'text.secondary', fontWeight: 700, letterSpacing: 1.2, mb: 1 }}
            >
              {t(cat.labelKey)}
            </Typography>
            <Grid container spacing={1.5}>
              {cat.tools.map((tool) => (
                <Grid item xs={12} sm={6} md={3} key={tool.path}>
                  <Paper
                    component={RouterLink}
                    to={tool.path}
                    elevation={0}
                    sx={{
                      display: 'flex', alignItems: 'center', gap: 1.25, p: 1.5,
                      borderRadius: 3, textDecoration: 'none', height: '100%',
                      border: '1px solid rgba(99,102,241,0.14)',
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        borderColor: 'rgba(99,102,241,0.45)',
                        background: 'rgba(99,102,241,0.05)',
                        transform: 'translateY(-2px)',
                      },
                    }}
                  >
                    <Box sx={{ color: 'primary.main', display: 'flex' }}>{tool.icon}</Box>
                    <Typography variant="body2" fontWeight={600} color="text.primary">
                      {t(tool.labelKey)}
                    </Typography>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Box>
        ))}
      </Container>
    </Box>
  );
}
